export default __webpack_public_path__ + "static/media/P10.039018bc.png";